import {timezones} from 'shared/lib/timezones';

import React from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import {userAPI, IUserOutput, IProfileForm} from 'entities/user';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import Select from 'shared/ui/Select/Select';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputName from 'shared/ui/Input/InputName';
import {getClientDefaultTimeZone} from 'shared/lib/datetime';

interface IUserEditFormProps{
    onSuccess: () => void,
    item: IUserOutput,
    onClose: () => void,
}

const UserEditForm: React.FC<IUserEditFormProps> = ({item, onSuccess, onClose}) => {
    const [changeTariff, {isLoading}] = userAPI.useUpdateUserMutation();
    const {register, handleSubmit, formState, control} = useForm<IProfileForm>({mode: 'onChange'});
    const {errors, isValid, isDirty} = formState;

    const onSubmit: SubmitHandler<IProfileForm> = async({timezone, ...rest}) => {
        try {
            await changeTariff({
                id: item?.id ?? 0,
                timezone: timezone ?? getClientDefaultTimeZone(),
                ...rest,
            }).unwrap();
            onSuccess();
        } catch (e) {
        }
    };

    return <form
        onSubmit={handleSubmit(onSubmit)}
        className="profile-form"
    >
        <ModalBodyWrapper>
            <FormGroupWithError
                error={errors?.first_name?.message}
                label="Имя"
            >
                <InputName
                    name="first_name"
                    placeholder="Имя"
                    control={control}
                    register={register}
                    defaultValue={item.first_name}
                    required
                />
            </FormGroupWithError>

            <FormGroupWithError
                error={errors?.last_name?.message}
                label="Фамилия"
            >
                <InputName
                    name="last_name"
                    placeholder="Фамилия"
                    control={control}
                    register={register}
                    defaultValue={item.last_name}
                    required
                />
            </FormGroupWithError>

            <FormGroupWithError
                error={errors?.timezone?.message}
                label="Часовой пояс"
            >
                <Select
                    control={control}
                    name="timezone"
                    data={timezones.map(zone => ({value: zone, label: zone}))}
                    defaultValue={item?.timezone ?? getClientDefaultTimeZone()}
                />
            </FormGroupWithError>
        </ModalBodyWrapper>
        <ModalBlockButton
            primaryButtonText={t`Сохранить`}
            primaryButtonType="submit"
            primaryButtonLoading={isLoading}
            primaryButtonDisabled={!isDirty || !isValid}
            secondaryButtonOnClick={onClose}
        />
    </form>;
};

export default UserEditForm;